
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  OnthejobDocument,
  GetOnTheJobDocumentRequest,
  GetOnTheJobDocumentResponse,
  DropdownDto,
} from "@/types";
import StatusBadge from "@/components/StatusBadge.vue";

export default defineComponent({
  name: "OnTheJobDocumentList",
  components: { StatusBadge },
  setup() {
    const {
      axios,
      error,
      success,
      setLoading,
      dayjs,
      onRouterPush,
      formatAppDate,
    } = usePlugin();
    const selectedDate = ref<Date[]>([
      dayjs()
        .startOf("month")
        .toDate(),
      dayjs()
        .endOf("month")
        .toDate(),
    ]);
    const division = ref(null);
    const department = ref(null);
    const onTheJobs = ref<OnthejobDocument[]>([]);
    const divisions = ref<DropdownDto[]>([]);
    const departments = ref<DropdownDto[]>([]);

    const onSearchDocuments = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetOnTheJobDocumentResponse>(
          "api/v1/services/onTheJobDocument",
          {
            fromDate: selectedDate.value[0],
            toDate: selectedDate.value[1],
            division: division.value,
            department: department.value,
          } as GetOnTheJobDocumentRequest
        );
        onTheJobs.value = result.data.onTheJobDocuments ?? [];
        divisions.value = result.data.divisions;
        departments.value = result.data.departments;
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onEditDocument = (id: string) => {
      onRouterPush({ name: "editOnTheJobDocument", params: { id: id } });
    };

    const onNewDocument = () => {
      onRouterPush({ name: "createOnTheJobDocument" });
    };

    onMounted(() => onSearchDocuments());
    return {
      onTheJobs,
      onNewDocument,
      onEditDocument,
      formatAppDate,
      selectedDate,
      onSearchDocuments,
      divisions,
      departments,
      division,
      department,
    };
  },
});
